export const FARE_TYPE_ENUM = ["Published", "Negotiated", "Corporate"];

/** Tailwind classes for OrderList `type: "tag"` (stacked below supplier) */
export const fareTypeTagTheme = {
  Published: {
    color: "text-emerald-800",
    background: "bg-emerald-500/20",
    className: "mt-1.5",
  },
  Negotiated: {
    color: "text-amber-800",
    background: "bg-amber-500/20",
    className: "mt-1.5",
  },
  Corporate: {
    color: "text-indigo-800",
    background: "bg-indigo-500/20",
    className: "mt-1.5",
  },
};

export function getFareTypeLabel(flightData) {
  const raw = flightData?.fareType;
  if (raw == null || raw === "") return "Published";
  const match = FARE_TYPE_ENUM.find(
    (v) => v.toLowerCase() === String(raw).trim().toLowerCase(),
  );
  return match ?? "Published";
}

/**
 * Order row element for fare type — use directly after the supplier tag.
 */
export function getFlightFareTypeTagElement(flightData) {
  const label = getFareTypeLabel(flightData);
  const styles = fareTypeTagTheme[label];
  return {
    type: "tag",
    value: label,
    className: styles.className,
    color: styles.color,
    background: styles.background,
  };
}

/**
 * Props for inline / cover markup (e.g. rename card) — pill below supplier.
 */
export function getFlightFareTypeCoverProps(flightData) {
  const label = getFareTypeLabel(flightData);
  const styles = fareTypeTagTheme[label];
  return {
    label,
    className: `${styles.color} ${styles.background} text-xs font-bold px-2 py-1 rounded-md mt-1`,
  };
}
